/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slim_Raw_Hare_BiteInputs */

const en_slim_raw_hare_bite = /** @type {(inputs: Slim_Raw_Hare_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New import`)
};

const de_slim_raw_hare_bite = /** @type {(inputs: Slim_Raw_Hare_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Import`)
};

/**
* | output |
* | --- |
* | "New import" |
*
* @param {Slim_Raw_Hare_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slim_raw_hare_bite = /** @type {((inputs?: Slim_Raw_Hare_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slim_Raw_Hare_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_slim_raw_hare_bite(inputs)
	return de_slim_raw_hare_bite(inputs)
});